import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateCalendarHolidaysRequestFailure() {
      return getState().isFailure;
    },
    isCreateCalendarHolidaysRequestPending() {
      return getState().isPending;
    },
    isCreateCalendarHolidaysRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
